<template>
    <kt-panel>
        <kt-panel-body>
            <form @submit.prevent="handleSubmit($event, product)">
                <kt-form-group v-if="product.define_amount_by_user">
                    <kt-form-label for="amount">
                        {{ $t('label.amount') }}
                    </kt-form-label>
                    <kt-form-control
                        type="number"
                        dir="ltr"
                        id="amount"
                        name="amount"
                        v-model="query.amount"
                    >
                    </kt-form-control>
                </kt-form-group>
                <kt-form-group v-if="product.name_option">
                    <kt-form-label for="buyer_name">
                        {{ $t('label.buyer_name') }}
                    </kt-form-label>
                    <kt-form-control
                        id="buyer_name"
                        name="buyer_name"
                        v-model="query.buyer_name"
                    >
                    </kt-form-control>
                </kt-form-group>
                <kt-form-group v-if="product.email_option">
                    <kt-form-label for="email">
                        {{ $t('label.email') }}
                    </kt-form-label>
                    <kt-form-control
                        dir="ltr"
                        id="email"
                        name="email"
                        v-model="query.email"
                    >
                    </kt-form-control>
                </kt-form-group>
                <kt-form-group v-if="product.phone_option">
                    <kt-form-label for="phone">
                        {{ $t('label.phone') }}
                    </kt-form-label>
                    <kt-form-control
                        dir="ltr"
                        id="phone"
                        name="phone"
                        v-model="query.phone"
                    >
                    </kt-form-control>
                </kt-form-group>
                <kt-form-group v-if="product.address_option">
                    <kt-form-label for="address">
                        {{ $t('label.address') }}
                    </kt-form-label>
                    <kt-form-textarea
                        id="address"
                        name="address"
                        v-model="query.address"
                    >
                    </kt-form-textarea>
                </kt-form-group>

                <kt-form-action class="product-btns mt-4">


                </kt-form-action>
            </form>
        </kt-panel-body>
    </kt-panel>
</template>

<script>
import { mapGetters } from 'vuex'
import $ from 'jquery'

export default {
    props: {
        submitForm: {
            type: Function,
            default: function(e, query) {}
        }
    },
    data() {
        return {
            query: {

            }
        }
    },
    computed: {
        ...mapGetters('product', [
            'product', 'status'
        ]),
        ...mapGetters('store', [
            'store', 'status'
        ]),
        ...mapGetters('cart',['cart'])
    },
    methods: {

        handleSubmit(e, query) {
            let form = $(e.target)
            let btn = $('#submit_btn')

            form.validate({
                rules: {
                    amount: {
                        required: this.product.define_amount_by_user ? true : false
                    },
                    buyer_name: {
                        required: this.product.name_option_switch ? true : false
                    },
                    email: {
                        required: this.product.email_option_switch ? true : false
                    },
                    phone: {
                        required: this.product.phone_option_switch ? true : false
                    },
                    address: {
                        required: this.product.address_option_switch ? true : false
                    },
                },
            });


            if(!form.valid()) {
                return
            }

            this.submitForm(e, query)
        }
    },
}
</script>

<style>
.product-btns{
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 30px;
}
</style>